import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import Icon from '../Icon';
/* eslint-disable */ /* tslint:disable */ const CloseThin = (props)=>/*#__PURE__*/ React.createElement(Icon, _object_spread({
        viewBox: "-2.4 21.6 9.7 9.7"
    }, props), /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("path", {
        d: "M7.3 22.4l-.7-.8-4.1 4.2-4.1-4.2-.8.8 4.2 4.1-4.2 4.1.8.7 4.1-4.1 4.1 4.1.7-.7-4.1-4.1z",
        className: "st0"
    })));
/* tslint:enable */ /* eslint-enable */ export default CloseThin;
